<div class="dialog-header">
  <h6 matDialogTitle id="sensor-trends-title">Sensor Trends</h6>
  <button
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div
    fxLayout="row"
    fxLayout.xs="column"
    class="site-layout"
    id="row-entity-header"
  >
    <div
      fxFlex="98%;"
      fxFlex.xs="80%"
      fxLayout="column"
      fxLayout.xs="column"
      style="padding-top: 10px; flex-direction: row"
    >
      <div>
        <div
          fxLayout="row"
          fxLayout.xs="column"
          style="align-items: center !important"
          class="site-layout"
        >
          <div fxFlex="5%;" fxFlex.xs="80%" class="entity-name-row">
            <mat-label id="entity-name">Entity Name:</mat-label>
          </div>
          <div
            fxFlex="15%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
            id="form-field"
          >
            <mat-form-field>
              <input
                matInput
                type="text"
                [(ngModel)]="entityName"
                name="loadname"
                id="loadname"
                readonly
              />
            </mat-form-field>
          </div>
          <div fxFlex="10%;" fxFlex.xs="80%" id="select-sensor-label">
            <mat-label id="select-sensors">Select Sensors:</mat-label>
          </div>
          <div
            fxFlex="15%;"
            fxFlex.xs="80%"
            fxLayout="column"
            fxLayout.xs="column"
            id="form-field-sensor-data"
          >
            <mat-form-field>
              <mat-select multiple [(ngModel)]="selectedSensorData">
                <mat-option
                  *ngFor="let item of sensorData"
                  [value]="item.sensorRId"
                >
                  {{ item.title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div id="date-range-label" fxFlex="10%;" fxFlex.xs="80%">
            <mat-label id="select-date-range"
              >Select Date Range:&nbsp;</mat-label
            >
          </div>
          <div
            fxFlex="30%;"
            fxFlex.xs="80%"
            fxLayout="row"
            fxLayout.xs="column"
            id="date-picker-md"
          >
            <div style="margin: 1rem">
              <input
                class="datepicker"
                type="text"
                ngxDaterangepickerMd
                [(ngModel)]="selectDateRange"
                [showCustomRangeLabel]="true"
                [alwaysShowCalendars]="true"
                [ranges]="ranges"
                [linkedCalendars]="true"
                [showClearButton]="true"
                (ngModelChange)="onChangeDateRange()"
              />
            </div>
          </div>
          <div
            fxFlex="20%;"
            fxFlex.xs="80%"
            fxLayout="row"
            fxLayout.xs="column"
            id="button-id"
          >
            <button
              class="button-primary"
              bciprimarybutton
              id="btn-generate"
              (click)="onGenerate()"
            >
              Generate
            </button>
            <div>&nbsp;</div>
            <button
              class="button-primary"
              bciprimarybutton
              id="btn-clean"
              (click)="onClean()"
            >
              Clean
            </button>
          </div>
        </div>

        <hr />
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div id="SensorTrendsContainer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <button
    type="button"
    class="button-primary pull-right alignClose"
    bciprimarybutton
    (click)="close(false)"
  >
    Close
  </button>
</mat-dialog-footer>
